'use client';

import { c as _c } from "react/compiler-runtime";
import type { UserGiftListParams } from '@module/apis/client-side/heart/type';
import SettingConfig from '@module/config/setting';
import useGiftListViewModel from '@module/helpers/channel/home/useGiftListViewModel';
import { cn } from '@module/lib/utils';
import useModalStore from '@module/stores/useModalStore';
import { ChannelCalendar } from '@module/svg/icons';
import { convertISOToDottedDateTimeString, convertISOToDottedFullDateString } from '@module/utils/date/convertDateFormat';
import formatNumberWithComma from '@module/utils/formatNumberWithComma';
import masking from '@module/utils/masking';
import BaseButton from '@pc/components/atoms/button/BaseButton';
import BasePagenation from '@pc/components/pagenation/BasePagenation';
import NotFoundDisplay from '@pc/components/result/NotFoundDisplay';
import TableItemsTotalNumber from '@pc/components/table/TableItemsTotalNumber';
import { Input } from '@pc/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@pc/components/ui/select';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@pc/components/ui/table';
import DatePickerModal from '@pc/containers/modal/date/DatePickerModal';
function GiftListContainer() {
  const $ = _c(99);
  const {
    userGiftList,
    searchId,
    startDate,
    endDate,
    currentPage,
    currentPageFirstOffset,
    searchType,
    setSearchType,
    setStartDate,
    setEndDate,
    setSearchId,
    setCurrentPage,
    isListEmpty,
    showStoreModal,
    showMessageModal,
    handleSearchClick
  } = useGiftListViewModel();
  const {
    pushModal,
    popModal
  } = useModalStore();
  let t0;
  if ($[0] !== endDate || $[1] !== popModal || $[2] !== pushModal || $[3] !== setEndDate || $[4] !== setStartDate || $[5] !== startDate) {
    t0 = type => {
      pushModal({
        content: <DatePickerModal title={type === "startDate" ? "\uAC80\uC0C9\uC2DC\uC791 \uC77C\uC790" : "\uAC80\uC0C9\uC885\uB8CC \uC77C\uC790"} defaultMonth={type === "startDate" ? startDate : endDate} selected={type === "startDate" ? startDate : endDate} onSelect={date => {
          if (!date) {
            return;
          }
          if (type === "startDate") {
            setStartDate(date);
          } else {
            setEndDate(date);
          }
          popModal();
        }} />
      });
    };
    $[0] = endDate;
    $[1] = popModal;
    $[2] = pushModal;
    $[3] = setEndDate;
    $[4] = setStartDate;
    $[5] = startDate;
    $[6] = t0;
  } else {
    t0 = $[6];
  }
  const showDatePickerModal = t0;
  let t1;
  if ($[7] !== setCurrentPage || $[8] !== setSearchType) {
    t1 = e => {
      setCurrentPage(1);
      setSearchType(e as UserGiftListParams['type']);
    };
    $[7] = setCurrentPage;
    $[8] = setSearchType;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  let t2;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SelectTrigger className="h-12 w-[200px] bg-transparent"><SelectValue placeholder={"\uAC74\uBCC4"} /></SelectTrigger>;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SelectContent><SelectItem value="each">건별</SelectItem><SelectItem value="period">기간별</SelectItem></SelectContent>;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t1) {
    t4 = <div><Select onValueChange={t1}>{t2}{t3}</Select></div>;
    $[12] = t1;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== showDatePickerModal) {
    t5 = () => showDatePickerModal("startDate");
    $[14] = showDatePickerModal;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = cn("mr-0 flex h-[48px] w-[146px] cursor-pointer items-center justify-between rounded-[8px] border-[1px] border-borderBg03 px-4 font-normal text-baseFg");
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== startDate) {
    t7 = convertISOToDottedFullDateString(startDate.toISOString(), "-");
    $[17] = startDate;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t7) {
    t8 = <span>{t7}</span>;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <ChannelCalendar style={{
      fontSize: 16
    }} />;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t5 || $[23] !== t8) {
    t10 = <div onClick={t5} className={t6}>{t8}{t9}</div>;
    $[22] = t5;
    $[23] = t8;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="mx-3 text-baseFg">~</div>;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== showDatePickerModal) {
    t12 = () => showDatePickerModal("endDate");
    $[26] = showDatePickerModal;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = cn("mr-2 flex h-[48px] w-[146px] cursor-pointer items-center justify-between rounded-[8px] border-[1px] border-borderBg03 px-4 font-normal text-baseFg");
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== endDate) {
    t14 = convertISOToDottedFullDateString(endDate.toISOString(), "-");
    $[29] = endDate;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t14) {
    t15 = <span>{t14}</span>;
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <ChannelCalendar style={{
      fontSize: 16
    }} />;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t12 || $[35] !== t15) {
    t17 = <div onClick={t12} className={t13}>{t15}{t16}</div>;
    $[34] = t12;
    $[35] = t15;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== setSearchId) {
    t18 = e_0 => setSearchId(e_0.currentTarget.value);
    $[37] = setSearchId;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== searchId || $[40] !== t18) {
    t19 = <Input placeholder={"\uC544\uC774\uB514 \xB7 \uB2C9\uB124\uC784"} containerClassName="mr-2 ml-3 ml w-[148px]" value={searchId} onChange={t18} />;
    $[39] = searchId;
    $[40] = t18;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <BaseButton type="submit" variant="primary" className="h-[48px] w-[68px] text-[17px]">검색</BaseButton>;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== handleSearchClick || $[44] !== t10 || $[45] !== t17 || $[46] !== t19) {
    t21 = <form className="flex items-center" onSubmit={handleSearchClick}>{t10}{t11}{t17}{t19}{t20}</form>;
    $[43] = handleSearchClick;
    $[44] = t10;
    $[45] = t17;
    $[46] = t19;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  let t22;
  if ($[48] !== t21 || $[49] !== t4) {
    t22 = <div className="flex w-full justify-between">{t4}{t21}</div>;
    $[48] = t21;
    $[49] = t4;
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  const t23 = userGiftList?.page.total ?? 0;
  let t24;
  if ($[51] !== t23) {
    t24 = <TableItemsTotalNumber className="mb-4 w-full" count={t23} />;
    $[51] = t23;
    $[52] = t24;
  } else {
    t24 = $[52];
  }
  let t25;
  let t26;
  let t27;
  let t28;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <col width="4%" />;
    t26 = <col />;
    t27 = <col />;
    t28 = <col width="7%" />;
    $[53] = t25;
    $[54] = t26;
    $[55] = t27;
    $[56] = t28;
  } else {
    t25 = $[53];
    t26 = $[54];
    t27 = $[55];
    t28 = $[56];
  }
  let t29;
  if ($[57] !== searchType) {
    t29 = searchType === "each" && <col width="15%" />;
    $[57] = searchType;
    $[58] = t29;
  } else {
    t29 = $[58];
  }
  let t30;
  let t31;
  if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <col width="5%" />;
    t31 = <col width="5%" />;
    $[59] = t30;
    $[60] = t31;
  } else {
    t30 = $[59];
    t31 = $[60];
  }
  let t32;
  if ($[61] !== t29) {
    t32 = <colgroup>{t25}{t26}{t27}{t28}{t29}{t30}{t31}</colgroup>;
    $[61] = t29;
    $[62] = t32;
  } else {
    t32 = $[62];
  }
  let t33;
  let t34;
  let t35;
  let t36;
  if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <TableHead>번호</TableHead>;
    t34 = <TableHead>선물한 회원</TableHead>;
    t35 = <TableHead>하트 개수</TableHead>;
    t36 = <TableHead>상태</TableHead>;
    $[63] = t33;
    $[64] = t34;
    $[65] = t35;
    $[66] = t36;
  } else {
    t33 = $[63];
    t34 = $[64];
    t35 = $[65];
    t36 = $[66];
  }
  let t37;
  if ($[67] !== searchType) {
    t37 = searchType === "each" && <TableHead>선물일</TableHead>;
    $[67] = searchType;
    $[68] = t37;
  } else {
    t37 = $[68];
  }
  let t38;
  let t39;
  if ($[69] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = <TableHead>선물</TableHead>;
    t39 = <TableHead>쪽지</TableHead>;
    $[69] = t38;
    $[70] = t39;
  } else {
    t38 = $[69];
    t39 = $[70];
  }
  let t40;
  if ($[71] !== t37) {
    t40 = <TableHeader><TableRow className="h-[50px]">{t33}{t34}{t35}{t36}{t37}{t38}{t39}</TableRow></TableHeader>;
    $[71] = t37;
    $[72] = t40;
  } else {
    t40 = $[72];
  }
  let t41;
  if ($[73] !== currentPageFirstOffset || $[74] !== searchType || $[75] !== showMessageModal || $[76] !== showStoreModal || $[77] !== userGiftList) {
    t41 = userGiftList?.list.map((record, idx) => <TableRow key={record.idx}><TableCell>{userGiftList.page.total - currentPageFirstOffset - idx}</TableCell><TableCell className="text-left">{`${record.userNick}(${masking(record.userId)})`}</TableCell><TableCell> {`${formatNumberWithComma(record.coin)} 개`}</TableCell><TableCell className={cn({
        "text-colorFg03": record.stat === "cancel"
      })}>{record.statHuman}</TableCell>{searchType === "each" && <TableCell>{convertISOToDottedDateTimeString(record.insertDateTime)}</TableCell>}<TableCell><button type="button" onClick={() => showStoreModal({
          giftId: record.userId,
          giftNick: record.userNick
        })}><img alt="gift" src={`${SettingConfig.S3_BUCKET_URL}/img/icon/ico_gift3.png`} width={22} height={22} /></button></TableCell><TableCell><button type="button" onClick={() => showMessageModal({
          userId: record.userId,
          userIdx: record.userIdx,
          userNick: record.userNick
        })}><img src={`${SettingConfig.S3_BUCKET_URL}/img/icon/letter.png`} alt="letter" width={20} height={20} /></button></TableCell></TableRow>);
    $[73] = currentPageFirstOffset;
    $[74] = searchType;
    $[75] = showMessageModal;
    $[76] = showStoreModal;
    $[77] = userGiftList;
    $[78] = t41;
  } else {
    t41 = $[78];
  }
  let t42;
  if ($[79] !== t41) {
    t42 = <TableBody>{t41}</TableBody>;
    $[79] = t41;
    $[80] = t42;
  } else {
    t42 = $[80];
  }
  let t43;
  if ($[81] !== t32 || $[82] !== t40 || $[83] !== t42) {
    t43 = <Table>{t32}{t40}{t42}</Table>;
    $[81] = t32;
    $[82] = t40;
    $[83] = t42;
    $[84] = t43;
  } else {
    t43 = $[84];
  }
  let t44;
  if ($[85] !== isListEmpty) {
    t44 = isListEmpty && <NotFoundDisplay text={"\uC120\uBB3C \uBC1B\uC740 \uD558\uD2B8 \uB0B4\uC5ED\uC774 \uC5C6\uC2B5\uB2C8\uB2E4."} />;
    $[85] = isListEmpty;
    $[86] = t44;
  } else {
    t44 = $[86];
  }
  const t45 = userGiftList?.page;
  let t46;
  if ($[87] !== currentPage || $[88] !== setCurrentPage || $[89] !== t45) {
    t46 = <BasePagenation currentPage={currentPage} setCurrentPage={setCurrentPage} pageData={t45} />;
    $[87] = currentPage;
    $[88] = setCurrentPage;
    $[89] = t45;
    $[90] = t46;
  } else {
    t46 = $[90];
  }
  let t47;
  if ($[91] !== t43 || $[92] !== t44 || $[93] !== t46) {
    t47 = <div className="w-full text-colorFg18">{t43}{t44}{t46}</div>;
    $[91] = t43;
    $[92] = t44;
    $[93] = t46;
    $[94] = t47;
  } else {
    t47 = $[94];
  }
  let t48;
  if ($[95] !== t22 || $[96] !== t24 || $[97] !== t47) {
    t48 = <div className="flex flex-col items-center">{t22}{t24}{t47}</div>;
    $[95] = t22;
    $[96] = t24;
    $[97] = t47;
    $[98] = t48;
  } else {
    t48 = $[98];
  }
  return t48;
}
export default GiftListContainer;